import * as React from "react";
import { PageBase, ProtectedTabs } from "../../../../components";
import { ETLCodes } from "../../../../locales";
import { ERoutes } from "../../../../ERoutes";
import { Tab } from "@blueprintjs/core";
import { AffixRequestExportListPage } from "./lists/AffixRequestExportListPage";
import { useTl, useApiService } from "../../../../hooks";
import { useParams, useHistory } from "react-router";
import { AffixRequestApi, ERequestType, AffixRequestSearch } from "../../../../api";

export interface IFciExportPageProps {}

export const FciExportPage: React.FunctionComponent<IFciExportPageProps> = (props) => {
  const { t } = useTl();
  const { tab = "newKennel" } = useParams<{ tab: string; state: string }>();
  const api = useApiService(AffixRequestApi);

  const exportNewKennel = React.useCallback(
    async (sobj: AffixRequestSearch) => await api.exportNewKennelRequests(sobj),
    [api]
  );

  const exportkennelImport = React.useCallback(
    async (sobj: AffixRequestSearch) => await api.exportKennelImportRequests(sobj),
    [api]
  );

  const exportKennelNameChange = React.useCallback(
    async (sobj: AffixRequestSearch) => await api.exportKennelNameChangeRequests(sobj),
    [api]
  );

  const exportKennelOwnershipChangeRequest = React.useCallback(
    async (sobj: AffixRequestSearch) => await api.exportOwnershipChangeRequests(sobj),
    [api]
  );

  const exportKennelExportRequest = React.useCallback(
    async (sobj: AffixRequestSearch) => await api.exportKennelExportRequests(sobj),
    [api]
  );

  const history = useHistory();
  return (
    <PageBase breadCrumbs={[{ text: t(ETLCodes.FCIAffixesExport), route: ERoutes.affixExport }]}>
      <ProtectedTabs
        id="exportTabs"
        onChange={(newTabId) => history.push(`${ERoutes.affixExport}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <Tab
          id="newKennel"
          title={t(ETLCodes.NewKennel)}
          panel={
            <AffixRequestExportListPage requestType={ERequestType.NewKennelRequest} exportFunc={exportNewKennel} />
          }
        />
        <Tab
          id="import"
          title={t(ETLCodes.ImportKennelRequest)}
          panel={
            <AffixRequestExportListPage
              requestType={ERequestType.KennelImportRequest}
              exportFunc={exportkennelImport}
            />
          }
        />
        <Tab
          id="nameChange"
          title={t(ETLCodes.KennelNameChangeRequest)}
          panel={
            <AffixRequestExportListPage
              requestType={ERequestType.KennelNameChangeRequest}
              exportFunc={exportKennelNameChange}
            />
          }
        />
        <Tab
          id="ownershipChange"
          title={t(ETLCodes.KennelOwnershipChangeRequest)}
          panel={
            <AffixRequestExportListPage
              requestType={ERequestType.KennelOwnershipChangeRequest}
              exportFunc={exportKennelOwnershipChangeRequest}
            />
          }
        />
        <Tab
          id="kennelExport"
          title={t(ETLCodes.KennelExportRequest)}
          panel={
            <AffixRequestExportListPage
              requestType={ERequestType.KennelExportRequest}
              exportFunc={exportKennelExportRequest}
            />
          }
        />
      </ProtectedTabs>
    </PageBase>
  );
};
